<template>
    <q-modal v-model="showEditDialog" no-backdrop-dismiss>
      <q-toolbar color="primary" style="justify-content:space-between; width:500px">
                <q-toolbar-title shrink>
                    <div>Редактрование списка поставщиков</div>    
                </q-toolbar-title>
        </q-toolbar>    
        <div class='q-pa-md q-mt-lg row no-wrap full-width justify-around items-center'>
            <q-input style='width:50%' v-model="postavshikValue" stack-label="Название поставщика" @keydown="checkEnter"/> 
            <div v-if='isEditMode'>
                <q-btn outline color='negative' label='отмена' @click='cancelEdit(true)'/>
                <q-btn class='q-mr-md q-ml-md' color='positive' label='Ok' @click='savePostavhik(true)'/>
            </div>
            <div v-if='!isEditMode'>
                <q-btn class='q-mr-md q-ml-md' color='positive' label='Добавить' @click='savePostavhik(true)'/>
            </div>
        </div>
        <div class='q-ma-lg q-pa-sm p-container'>
            <div v-for="(item, key) in postavshikList" :key=key class='myLine q-pa-sm q-body-2 text-faded'>
                <div class='row no-wrap items-center'>
                    <q-btn flat dense icon='edit' color='primary' @click='editPostavshik(item)' v-if='!isLocked(item)'/>
                    
                    <q-icon v-if='isLocked(item)' name="lock" color="red-10" class='q-ma-sm' v-on:dblclick.native="forceUnlock(item)"/> <!-- если запись залочена -->

                    <div class='q-ml-md'>{{item.name}}</div>
                </div>
                <q-card-separator/>
            </div>
        </div>

        <q-card-separator/>
        <div class='row no-wrap justify-end'>
            <q-btn icon='close' label='Закрыть диалог' color='positive' class='q-ma-md' @click='closeDialog'/>
        </div>

    </q-modal>
</template>
<script>
/* eslint-disable */
export default {
    name : 'postavshikDialog',

    data() {
        return {
            showEditDialog : false,
            isEditMode : false,
            postavshikValue : null,
            editId : null,
        }
    },

    created() {
        if (this.$store.getters.getPostavshiks.length = 0) { // если список поставщиков пустой - то пробуем загрузить его с сервера
            this.$store.dispatch('getAllPostavshiks');
        }

        eventBus.$on("showPostavshikDialog", ()=> {
            this.showEditDialog = true; // показываем диалоговое окно
            this.isEditMode = false;
            this.postavshikValue = null;
            this.editId = null;
        });

    },

    beforeDestroy() {
        eventBus.$off('showPostavshikDialog');
    },

    computed : {
        postavshikList() {
            let q = this.$store.getters.getPostavshiks;
            return q != null ? q : [];
        }
    },

    methods : {

        checkEnter(key) {
            if (key.key=='Enter') {
                this.savePostavhik(true);
            }
        },

        forceUnlock(item) { //принудительная разблокировка заказа
            //сначала спрашиваем
            this.$q.dialog({
                    title: 'Принудительная разблокировка',
                    message: 'Подтвердите принудительную разблокировку. Надеемся это Вам действительно необходимо.',
                    color: 'primary',
                    ok: 'Разблокировать', 
                    cancel: 'Отмена',
            })
            .then(()=> {
                this.$store.dispatch('unlockPostavshik', item.id)
                .then(() => {
                    this.$admns.showNotify('Запись разблокирована.','success','Сообщение системы')
                })
                .catch((error) => {
                    this.$admns.showNotify('Ошибка при разблокировке','error','Сообщение системы')
                });

            })
            .catch();
        },
        
        isLocked(item) {
            return item.lock_at != null;
        },

        cancelEdit(isShowDialog) {
            return new Promise((resolve, reject) => {
                this.$store.dispatch('unlockPostavshik', this.editId)
                    .then((response)=>{
                        this.isEditMode = false;
                        this.editId = null;
                        this.postavshikValue = null; 
                        this.showEditDialog = isShowDialog;
                        resolve();
                    })
                    .catch(error => {
                        console.log(error);
                        this.$admns.showNotify('Не могу разблокировать запись','error','сообщение системы');
                        reject();
                    });
            });
        },

        lockAndEdit(item) {
            this.$store.dispatch('lockPostavshik', item.id)
            .then((response)=>{
                this.isEditMode = true;
                this.editId = item.id;
                this.postavshikValue = item.name;            
            })
            .catch(error => {
                console.log(error);
                this.$admns.showNotify('Не могу заблокировать запись','error','сообщение системы');
            });
        },
        
        editPostavshik(item) {
            if (this.isEditMode) {
                this.$q.dialog({
                    title: 'Внимание!',
                    message: 'Запись не сохранена. Сохранить?',
                    color: 'primary',
                    ok: 'Сохранить', // takes i18n value, or String for "OK" button label
                    cancel: 'Не сохранять', // 
                })
                .then(() => { // если ок - то сохраняем
                    this.savePostavhik(true)
                    .then(()=>{
                        this.cancelEdit(true);
                    })
                    .catch();
                })
                .catch(() => { // не сохраняем данные, но разлочиваем запись
                    this.cancelEdit(true)
                    .then(()=>{this.lockAndEdit(item)})
                    .cath();
                    
                });
            } else {
            // сначала надо лочить поставщика
                this.lockAndEdit(item);
            }

        },

        savePostavhik(closeDialog) {
            if (this.postavshikValue.trim()=='') {
                this.$admns.showNotify('Имя поставщика пустое!','error','сообщение системы');
                return;
            }
            return new Promise((resolve, reject) => {
                this.$store.dispatch('savePostavshik', {id:this.editId, name:this.postavshikValue})
                    .then((response)=>{
                        this.isEditMode = false;
                        this.editId = null;
                        this.postavshikValue = null;            
                        this.showEditDialog = closeDialog;
                        resolve();
                    })
                    .catch(error => {
                        console.log(error);
                        this.$admns.showNotify('Не могу разблокировать запись','error','сообщение системы');
                        reject(error);
                    });
            });
            


        },

        closeDialog() {
            if (this.isEditMode) { // значит редактируется - спрашиваем сохранить и разлочиваем
                this.$q.dialog({
                    title: 'Внимание!',
                    message: 'Изменения не сохранены! Сохранить перед закрытием?',
                    color: 'primary',
                    ok: 'Сохранить', // takes i18n value, or String for "OK" button label
                    cancel: 'Не сохранять', // 
                })
                .then(() => { // если ок - то разлочиваем и закрываем нахер
                    this.savePostavhik(false);
                })
                .catch(() => { // не сохраняем данные, но разлочиваем запись
                    this.cancelEdit(false);
                });
            } else { // если не редактируем - то тупо закрыаем окно
                this.showEditDialog = false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .myLine {
        &:hover{
            background: rgb(221, 255, 214) !important;
        }
    }
    .p-container {
        border : 1px solid rgb(190, 190, 190);
    }
</style>


